<template>
    <div :class="`search-item pharmacy_site ${isGrid ? 'grid' : 'bar'}`">
        <div v-if="isGrid" cols="12" class="search-item-grid-details"></div>
        <v-row v-else no-gutters>
            <v-col cols="12" class="p-0 pb-2">
                <div class="grid-status">
                    <span v-text="t(`search::types.${searchItem.type}`)"></span>
                </div>
            </v-col>
            <v-col v-if="searchItem.name" cols="12" class="p-0 pb-1 field name">
                <span v-if="searchItem.name">
                    {{ searchItem.name }}
                </span>
                <span v-else>
                    {{ t('default::label.na') }}
                </span>
            </v-col>
        </v-row>
        <div v-if="can('pharmacy-sites.get') && !isGrid" class="search-item-actions">
            <v-tooltip top transition="v-fab-transition" z-index="999999">
                <template #activator="{ on, attrs }">
                    <div
                        class="search-item-actions-button"
                        v-bind="attrs"
                        v-on="on"
                        @click="$root.goTo(editItemUrl(item))"
                    >
                        <v-icon size="18">mdi-arrow-right</v-icon>
                    </div>
                </template>
                <span>{{ t('search::label.actions.go_to_record') }}</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
import SearchMixin from '../..//mixins/SearchMixin';
export default {
    mixins: [SearchMixin],
    methods: {
        editItemUrl(item) {
            return route('pharmacy-sites.get', { id: item.id });
        },
    },
};
</script>

<style></style>
